import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { HrefDirective } from '../../../directives/href/href.directive';
import { NotificationComponent } from '../../../components/notification/notification.component';

import { TickerSymbolStatus } from '../ticker-symbol.domain';

@Component({
  selector: 'td-wb-ticker-symbol-notification',
  templateUrl: 'ticker-symbol-notification.component.html',
  imports: [
    TranslateDirective,
    NotificationComponent,
    HrefDirective
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TickerSymbolNotificationComponent {
  @Input() notificationStatus: TickerSymbolStatus;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  readonly SymbolStatus: typeof TickerSymbolStatus = TickerSymbolStatus;
}
